let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("uIkuA")).then(() => parcelRequire('acVWB'));